<template>
    <a class="nav-link" href="#" role="button" @click="toggle">
        <i class="fa fa-bars"></i>
    </a>
</template>

<script>

import { useStore, mapState } from 'vuex'

export default {
    data() {
        return {
            sidebarElementId: 'sidebar-overlay'
        }
    },
    computed: {
        ...mapState({
            openSidebar: state => state.openSidebar
        }),
    },
    methods: {
        toggle(){
            this.$store.commit('toggleSidebar', !this.openSidebar);
        },
        isOpen() {
            return document.getElementsByTagName('body')[0].classList.contains('sidebar-open');
        }
    },
    mounted(){
        const self = this;
        window.onresize = function(event) {
            if((self.openSidebar && window.innerWidth <= 1050) || (!self.openSidebar && window.innerWidth > 1050))
                self.toggle();
        };

        if(self.openSidebar && window.innerWidth <= 1050)
            self.toggle();
    }
}
</script>